import React, { Component, useState } from 'react'
import {connect} from 'react-redux'
import { Table, FormControl, Image } from 'react-bootstrap'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment'
import 'moment/locale/de'

import '../../index.css'

moment.locale('de')

const TransactionHistory = ({ inventory }) => {
    const dummy_showRows = (type, index) => {
        return (
            <div >
                <Table className="nostriped" className="table-sm" >
                    <thead>
                        <tr className="test">
                            <th className="imageColumn"></th>
                            <th>{type.articleType}</th>
                            <th className="sizeColumn">XS</th>
                            <th className="sizeColumn">Total</th>
                        </tr>
                    </thead>

                    <tbody className="mappedColumns">
                        {type.articleEntries.slice(index, index + 1).map(entry => {
                            return (
                                <tr className="test">
                                    <td className="imageColumn">
                                        <Image className="thumbnail" src={entry.articleImage} thumbnail />
                                    </td>
                                    <td>{entry.articleEntry}</td>
                                    <td class="sizeColumntd">6</td>
                                    <td className="sizeColumntd">22</td>
                                </tr>
                            )
                        }
                        )}
                    </tbody>
                </Table>
            </div>
        )
    }

    const subRow = () => {
        return (
            <>
                {inventory.slice(0, 1).map(item => dummy_showRows(item, 1))}
            </>
        )
    }

    const subRowIndicator = () => {
        console.log("SubRowIndicator: ")
        console.log(inventory.slice(0, 1).map(item => item.articleEntries.slice(1, 2)))
        let subrow = inventory.slice(0, 1)[0].articleEntries.slice(1, 2)
        let arr = []
        arr.push(subrow[0].articleEntry)
        //arr.push(subrow[0].articleEntry, subrow[0].articleNumber, subrow[0].gender, subrow[0].price, subrow[0].style)
        //subrow[0].sizeEntries.forEach(x => arr.push(x.amount)) //SizeEntries shouldn't be filterable
        console.log(arr)
        return arr
    }

    const dateNow = new Date()

    const data = [{ "id": 1234, "type": "Verkauf", "date": "03.10.2020", "status": "unterwegs", "subRow": subRow(), "subRowIndicator": subRowIndicator() },
    { "id": 2576, "type": "Ausgehende Lieferung", "date": "01.10.2020", "status": "Ware eingetroffen", "subRow": subRow(), "subRowIndicator": subRowIndicator() }]
    const [expandedRows, setExpandedRows] = useState([])

    const rowIdWithContent = [{
        key1: "value1",
        key2: "value2"
    }];

    const handleRowClick = (rowId) => {
        const currentExpandedRows = expandedRows;
        const isRowCurrentlyExpanded = currentExpandedRows.includes(rowId);

        const newExpandedRows = isRowCurrentlyExpanded ?
            currentExpandedRows.filter(id => id !== rowId) :
            currentExpandedRows.concat(rowId);

        setExpandedRows(newExpandedRows)
    }

    const renderItem = (item) => {
        const clickCallback = () => handleRowClick(item.id);
        const itemRows = [
            <tr onClick={clickCallback} key={"row-data-" + item.id}>
                {expandedRows.includes(item.id) ? <td className="expandIndicator">&#8722;</td> : <td className="expandIndicator">&#43;</td>}
                <td>{item.id}</td>
                <td>{item.type}</td>
                <td>{item.date}</td>
                <td>{item.status}</td>
                <td></td>
                <td hidden>{item.subRow}</td>
                <td hidden>{item.subRowIndicator}</td>
            </tr>
        ];

        if (expandedRows.includes(item.id)) {
            if (item.id == 1234) {
                console.log("Item SubRow: ")
                console.log(item.subRow)
                itemRows.push(
                    <tr key={"row-expanded-" + item.id}>
                        <td colSpan="6">
                            {item.subRow}
                        </td>
                    </tr>
                );
            } else {
                itemRows.push(
                    <tr key={"row-expanded-" + item.id}>
                        <td colSpan="6">
                            {item.subRow}
                        </td>
                    </tr>
                );
            }
        }

        return itemRows;
    }

    let allItemRows = [];

    data.forEach(item => {
        const perItemRows = renderItem(item);
        allItemRows = allItemRows.concat(perItemRows);
    });

    const [filterInput, setFilterInput] = useState("")

    const handleInput = (e) => {
        setFilterInput(e.target.value)
    }

    const [selectFilterInput, setSelectFilterInput] = useState("")
    const [dateFilterInput, setDateFilterInput] = useState("")

    const filteredElements = () => {
        const allItemRowsCache = allItemRows
        let filteredBool = false

        console.log("AllItemRows: ")
        console.log(allItemRows)

        if (filterInput.trim() != "") {
            allItemRows = allItemRows.filter(row => (row.key.includes("row-data-") && row.props.children.some(x => x.props.children != undefined && x.props.children.toString().toLocaleLowerCase().includes(filterInput.toLocaleLowerCase().toString()))))
            filteredBool = true
        }
        if (selectFilterInput != "Alle" && selectFilterInput != "") {
            allItemRows = allItemRows.filter(row => (row.key.includes("row-data-") && row.props.children.some(x => x.props.children != undefined && x.props.children == selectFilterInput)))
            filteredBool = true
        }
        if (dateFilterInput != "") {
            const startDate = moment(dateFilterInput.start._d).format("DD/MM/YYYY")
            const endDate = moment(dateFilterInput.end._d).format("DD/MM/YYYY")

            allItemRows = allItemRows.filter(row => (row.key.includes("row-data-")) &&
                ((moment(moment(row.props.children[3].props.children, "DD.MM.YYYY").format("DD/MM/YYYY"))).isSameOrBefore(endDate) &&
                    (moment(moment(row.props.children[3].props.children, "DD.MM.YYYY").format("DD/MM/YYYY"))).isSameOrAfter(startDate)))

            filteredBool = true
        }

        if (filteredBool == true) {
            for (let row of allItemRowsCache) {
                if (row.key.includes("row-expanded-") && allItemRows.some(x => x.key.includes("row-data-" + row.key.split("-")[2]))) {
                    let index = allItemRows.findIndex(x => x.key.includes(row.key.split("-")[2])) + 1
                    allItemRows.splice(index, 0, row)
                }
            }
        }
        return allItemRows
    }

    const [filterable, setFilterable] = useState(false)
    const setFilterbar = () => {
        setFilterable(!filterable)
    }

    const selectFilteredElements = (e) => {
        setSelectFilterInput(e.target.value)
    }

    const StatusSelect = () => {
        return (
            <FormControl className="filterForm" defaultValue={selectFilterInput} as="select" size="sm" onChange={selectFilteredElements}>
                <option>Alle</option>
                <option>unterwegs</option>
                <option>Ware eingetroffen</option>
            </FormControl>
        )
    }

    const handleDatePickerCallback = (start, end) => {
        setDateFilterInput({ start, end });
    };
    
    const DateSelect = () => {
        const startDate = Date.now();
        const endDate = Date.now();
        return (
            <DateRangePicker initialSettings={{ startDate, endDate }} onCallback={handleDatePickerCallback}>
                <FormControl className="dateFilterForm" size="sm" />
            </DateRangePicker>
        );
    }

    return (
        <div>
            <FormControl className="globalSearch" as="input" placeholder="Suche..." onChange={handleInput}></FormControl>

            <Table striped className="table-sm">
                <thead>
                    <th></th>
                    <th className="mainColumn">LieferID</th>
                    <th className="mainColumn">Art</th>
                    <th className="mainColumn">Erstellungsdatum</th>
                    <th className="mainColumn">Status</th>
                    <th className="filterIndicator" onClick={setFilterbar}>&#8711; Filter</th>
                </thead>
                    {filterable ? <thead>
                        <th></th><th></th><th></th>
                        <th>{DateSelect()}</th><th>{StatusSelect()}</th>
                    </thead> : null}
                <tbody>
                    {filteredElements()}
                </tbody>
            </Table>
        </div>
    );
}

const mapStateToProps = state => ({
    inventory: state.inventory
})

export default connect(mapStateToProps)(TransactionHistory)
